export default __webpack_public_path__ + "static/N0038-9cc5f142d9d117ad169f07d2e6896be1.png";